import { createFeatureSelector } from '@ngrx/store';
import { BasketItem, CreateAccountParameters, GetOrderSummary, GetQuoteRequest } from 'src/app/shared';

export const selectBasketItems = createFeatureSelector<BasketItem[]>('basketItems');
export const selectBasketAccount = createFeatureSelector<CreateAccountParameters>('basketAccount');
export const selectBasketQuote = createFeatureSelector<GetQuoteRequest>('basketQuote');
export const selectBasketSummary = createFeatureSelector<GetOrderSummary>('basketSummary');
